<style src="css/courseList.css" scoped></style>
<template>
    <div style="padding-top: 1rem">
        <topbar text="全部课程" status="true"></topbar>
        <header class="classify-header-wrapper">
            <div class="classify-header-scroll-wrapper">
                <div class="classify-header">
                    <span :class="{actived: currentClassify === 0}" @click="selectClassify(0)">全部</span>
                    <span :class="{actived: currentClassify === 1}" @click="selectClassify(1)">情绪</span>
                    <span :class="{actived: currentClassify === 2}" @click="selectClassify(2)">压力</span>
                    <span :class="{actived: currentClassify === 3}" @click="selectClassify(3)">恋爱</span>
                    <span :class="{actived: currentClassify === 4}" @click="selectClassify(4)">人际关系</span>
                    <span :class="{actived: currentClassify === 5}" @click="selectClassify(5)">自我意识</span>
                    <span :class="{actived: currentClassify === 6}" @click="selectClassify(6)">积极心理学</span>
                    <span :class="{actived: currentClassify === 7}" @click="selectClassify(7)">绘画心理课程</span>
<!--                    <span :class="{actived: currentClassify === -2}" @click="selectClassify(-2)">最热</span>-->

<!--                    <span :class="{actived: currentClassify === item.id}" v-text="item.name"-->
<!--                          v-for="(item,index) of classify" @click="selectClassify(item.id)" :key="index"></span>-->
                </div>
            </div>
        </header>
        <ul class="courseList" v-if="!emptyStatus">
            <li v-for="item in scaleUserFavoriteList" @click="to(`courseDetail?microId=${item.microId}`)">
                <div class="itemLeftBox">
                    <div class="itemTitle">{{item.name}}</div>
                    <div class="itemTimeBox">{{item.duration | isDuration}} <span>{{item.readCount}}人已参加</span></div>
                </div>
                <div class="itemRightBox" :style="{background: `url(${item.pic}) no-repeat center/cover`}">
<!--                    <div class="free">免费</div>-->
<!--                    <div class="vip"></div>-->
                </div>
            </li>
        </ul>
        <no-more-data :noMoreData="noMoreData"></no-more-data>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                slidesReal: [],
                scaleLabelList: [],
                scaleUserFavoriteList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: 0,
                userId: '',

                currentClassify:0,
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isDuration(value){
                let result = parseInt(value)
                let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
                let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
                let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

                let res = '';
                if(h !== '00') res += `${h}:`;
                if(m !== '00') res += `${m}:`;
                res += `${s}`;
                return res;
            }
        },
        computed: {},
        methods: {
            selectClassify(n){
                if(n===0){
                    this.emptyStatus=false
                }else{
                    this.emptyStatus=true
                }
                this.currentClassify=n;
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getScaleUserFavoriteList()
                    }
                }
            },
            async getScaleUserFavoriteList() {
                let obj = {}
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                // obj.userId = this.userId;
                obj.companyId = localStorage.getItem('companyId')?localStorage.getItem('companyId'):''
                let data = await getSources("/bear-scale/api/micro/getMicroList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.scaleUserFavoriteList = [...this.scaleUserFavoriteList, ...data.microList];
                    if (data.microList.length == 0) {
                        this.emptyStatus = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }

                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.userId=localStorage.getItem('userId')
            this.getScaleUserFavoriteList();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/courseList.vue?17323f37